<template>
    <hts-router-drawer
        :title="$t('labels.editContact')"
        :size="50"
        :submit="submit"
        is-close
        :rules="rulesCooperatorContact"
        @loaded="getData"
        @refresh-tables="refreshTables">
        <hts-card :title="$t('labels.generalInformation')">
            <hts-form-input
                v-model="formData.fullName"
                :label="$t('labels.fullName')"
                required
                prop="fullName"
                name="fullName"
                :color="props.color" />
            <hts-form-phone
                v-model="formData.phone"
                :label="$t('labels.phone')"
                required
                prop="phone"
                name="phone"
                @updateCode="(val) => (formData.phone.code = val)" />
            <hts-form-input
                v-model="formData.email"
                :label="$t('labels.email')"
                required
                prop="email"
                name="email"
                :color="props.color" />
            <hts-form-input
                v-model="formData.office"
                :label="$t('labels.office')"
                required
                prop="office"
                name="office"
                :color="props.color" />
            <hts-form-select
                v-model="formData.department"
                :label="$t('labels.department')"
                required
                :items="departments"
                key-id="key"
                key-label="value"
                prop="department"
                name="department" />

            <hts-select-node
                v-if="formData.department === 'LOGISTIC'"
                v-model="formData.warehouses"
                :label="$t('labels.nodeModule.warehouse')"
                key-label="locationName"
                :multiple="true"
                :node-detail="formData.warehouseDetails"
                type="WAREHOUSE"/>

            <hts-form-date
                v-model="formData.birthday"
                :label="$t('labels.birthday')"
                type="date"
                :color="props.color"
                name="birthday"
                prop="birthday" />

            <hts-form-input
                v-model="formData.description"
                :label="$t('labels.description')"
                name="description"
                prop="description" />
        </hts-card>
    </hts-router-drawer>
</template>

<script setup lang="ts">
import data from '../ignore/data'
const { departments } = data()

const rulesCooperatorContact = {
  fullName: 'required',
  phone: 'required',
  email: 'required|regexEmail',
  office: 'required',
  department: 'required'
}

const cooperatorId = computed(() => useRoute().params.idpartner)
const cooperatorContactId = computed(() => useRoute().params.idcontact)
const visible = ref(false)
const loading = ref(false)
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  }
})

const formData = reactive({
  cooperator: '',
  fullName: '',
  phone: {}, // phone laf object
  email: '',
  office: '',
  birthday: '',
  department: '',
  warehouses: [],
  warehouseDetails: [],
  description: ''
})
const emits = defineEmits(['refreshTables'])

const refreshTables = () => {
  emits('refreshTables')
}

const submit = async () => {
  const api = {
    url: '/partner/contact/cooperatorId/update/cooperatorContactId',
    method: 'put'
  }
  const data: any = await $api(api, { uriParams: { cooperatorId: cooperatorId.value, cooperatorContactId: cooperatorContactId.value }, body: formData })
  const resData = data?.data?.value
  if (resData && resData.success) {
    if (resData.success) {
      process.client && $toast().success($t('labels.editContactSuccess'))
      close()
      emits('refreshTables')
    }
  }
}

const getData = () => {
  const api = {
    url: '/partner/contact/cooperatorId/detail/cooperatorContactId',
    method: 'get'
  }
  $api(api, { uriParams: { cooperatorId: cooperatorId.value, cooperatorContactId: cooperatorContactId.value } }).then((data: any) => {
    const resData: any = data.data.value
    if (resData.success) {
      loading.value = true
      if (!resData.data.cooperatorPolicy) {
        delete resData.data.cooperatorPolicy
      }
      Object.assign(formData, { ...resData.data })
    }
  })
}
</script>
